import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const WorkFlowData = () => {

    const sections = [
        { label: "Entity Type", value: "EntityType", items: [] },
    ];

    return (
        <MasterData pageTitle="Workflow" sections={sections} />
    );
};

export default WorkFlowData;